export const styles = {
  button: {
    fontFamily: '"Proxima Nova", sans-serif',
    lineHeight: '20px',
    border: '1px solid #00112B',
    borderRadius: '16px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '48px',
    width: '208px',
    cursor: 'pointer',
    textTransform: 'none',
    color: '#00112B',
    fontSize: '16px',
    fontWeight: 700,
    '&:hover': {
      background: '#004360',
      border: '1px solid #004360',
      color: '#FFFFFF',
    },
    '@media screen and (max-width: 768px)': {
      width: '100%',
      maxWidth: '546px',
      height: '40px',
    },
  },
  alwaysActive: {
    background: '#004360',
    border: '1px solid #004360',
    color: '#FFFFFF',
    '&:hover': {
      background: '#004360',
      border: '1px solid #004360',
      color: '#FFFFFF',
    },
  },
}
